import { gql } from '@apollo/client';

export const ALL_PERSONNEL_POSITIONS = gql`
  query AllPersonnelPositions {
    personnelPositions: getPersonnelPositions {
      id
      name
    }
  }
`;
